// import moment from 'moment';
import moment from 'moment-timezone'

class SortService {
  sortDate(date) {
    const newDate = new Date(date);

    const year = newDate.getFullYear();
    const month = (newDate.getMonth() + 1).toString().length === 1 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1;
    const day = newDate.getDate().toString().length === 1 ? `0${newDate.getDate()}` : newDate.getDate();

    const hours = newDate.getHours().toString().length === 1 ? `0${newDate.getHours()}` : newDate.getHours();
    const minutes = newDate.getMinutes().toString().length === 1 ? `0${newDate.getMinutes()}` : newDate.getMinutes();
    const seconds = newDate.getSeconds().toString().length === 1 ? `0${newDate.getSeconds()}` : newDate.getSeconds();

    const fullDate = `${month}/${day}/${year}`;
    const fullTime = `${hours}:${minutes}:${seconds}`;

    return [fullDate, fullTime];
  }

  capitalizeText(stringArray) {
    return stringArray.map(str => str.charAt(0).toUpperCase() + str.slice(1));
  }

  formatDate(date) {
    let updatedDate = moment(date);
    return `${updatedDate.tz('America/Los_Angeles').format('L')} ${updatedDate.tz('America/Los_Angeles').format('LTS')}`;
  }

  formatDateTo(date, to) {
    let updatedDate = moment(date, 'America/Los_Angeles');
    return `${updatedDate.tz(to).format('L')} ${updatedDate.tz(to).format('LTS')}`;
  }

  formatDatetime(items) {
    let correctDate = [];
    items.forEach((item) => {
      correctDate.push({ value: item, label: this.formatDate(item) });
    });

    return correctDate;
  }

  formatCreatedAtInObject(items) {
    items.forEach(item => {
      item.createdAt = this.formatDate(item.createdAt);
    });

    return items;
  }

  formatDateTimeFieldInObject(items, field) {
    items.forEach(item => {
      item.datetime_old = new Date(item[field]).toISOString().slice(0, 19).replace('T', ' ');
      item[field] = this.formatDate(item[field]);
    });

    return items;
  }

  sortLead(lead) {

    if (lead.birth_date) {
      const birth = lead.birth_date.split('-');
      lead.birth_year = birth[0];
      lead.birth_month = birth[1];
      lead.birth_day = birth[2];
    }

    let updatedLeadDate = moment(lead.updated);
    let formatUpdatedLeadDate = `${updatedLeadDate.tz('America/Los_Angeles').format('L')} ${updatedLeadDate.tz('America/Los_Angeles').format('LTS')}`;
    lead.updated = formatUpdatedLeadDate;

    if (lead.pc) {
      const prices = JSON.parse(lead.pc);

      lead.premium_price = `$${prices[Object.keys(prices)[0]]}`;

      lead.premium_carrier = this.capitalizeText(Object.keys(prices)[0].split('_')).join(' ');
    } else {
      const prices = this.premiumCompany(lead.price, lead.rate_class);

      lead.premium_price = `$${prices[0]}`;

      lead.premium_carrier = this.capitalizeText(prices[1].split('_')).join(' ');
    }

    //Sort the client information
    lead.children = lead.howchildren == null ? +Boolean(lead.howchildren) : 0;
    lead.howchildren = lead.children == 0 ? null : lead.howchildren;

    //Sort the quote information
    lead.mortgage = lead.mortgage_remaining == null || lead.term === "fex" ? 0 : 1;
    lead.mortgage_remaining = lead.mortgage == 0 ? null : lead.mortgage_remaining;

    lead.disability = lead.policy == 0 && lead.term !== "fex" ? null : lead.disability;
    lead.policy = lead.disability == null ? 0 : 1;

    lead.height = Number(lead.height);
    lead.jobstatus = lead.term === "fex" ? null : lead.jobstatus;
    lead.coverage_amount = Number(lead.coverage_amount);

    if (typeof lead.medications === 'string') lead.medications = [lead.medications];

    if (lead.gender) {
      lead.gender = lead.gender.toLowerCase();
    }

    lead.price = this.sortPrices(lead.price);

    return lead;
  }

  sortLeads(leads) {
    leads.forEach(lead => {
      let updatedLeadDate = moment(lead.updatedAt);
      let formatUpdatedLeadDate = `${updatedLeadDate.tz('America/Los_Angeles').format('L')} ${updatedLeadDate.tz('America/Los_Angeles').format('LTS')}`;
      lead.updated = formatUpdatedLeadDate;

      if (lead.pc) {
        const prices = JSON.parse(lead.pc);

        if (Object.keys(prices).length > 0) {
          lead.premium_price = `$${prices[Object.keys(prices)[0]]}`;
          lead.premium_carrier = this.capitalizeText(Object.keys(prices)[0].split('_')).join(' ');
        }
      } else {
        const prices = this.premiumCompany(lead.price, lead.rate_class);

        if (Object.keys(prices).length > 0) {
          lead.premium_price = `$${prices[0]}`;
          lead.premium_carrier = this.capitalizeText(prices[1].split('_')).join(' ');
        }
      }
    });

    return leads;
  }

  sortHealthLead(lead) {
    if (lead.birth_date) {
      const birth = lead.birth_date.split('-');
      lead.birth_year = birth[0];
      lead.birth_month = birth[1];
      lead.birth_day = birth[2];
    }

    if (lead.type_id === 4) {
      let medications = [];
      const key_med = 'major_condition_';

      for (const [key, value] of Object.entries(lead)) {
        if (key.includes(key_med) && value) {
          medications.push(key);
          delete lead[key];
        }
        if (key.includes(key_med)) delete lead[key];
      }

      lead.medications = medications;
    }

    return lead;
  }

  sortPrices(pricesObj) {
    const prices = [];

    for (let price in pricesObj) {
      prices.push([price, pricesObj[price]]);
    }
    prices.sort((a, b) => a[1] - b[1]);

    const resultObject = {};
    prices.forEach(item => resultObject[item[0]] = item[1]);

    return resultObject;
  }

  premiumCompany(priceObj, rate_class) {
    let premium = 0;
    let carrier = "-";
    let companies = [];

    for (let key in priceObj) {
      let price = parseFloat(priceObj[key]);
      let company = {
        "premium": price,
        "carrier": key
      }
      if (price > 0 && key != 'american_general') {
        companies.push(company);
      }

      if (key != 'american_general' && rate_class == "gi") {
        companies.push(company);
      }
    }

    if (companies.length > 0) {
      companies.sort((a, b) => a.premium - b.premium);
      premium = companies[0].premium;
      carrier = companies[0].carrier;
    }

    return [premium, carrier];
  }

  /*
    * Formating number e.g 1000 on 1,000
    */
  numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  }

  sortDateToUserTimeZone(date) {
    let updatedDate = moment(date);
    return `${updatedDate.tz(moment.tz.guess()).format('L')} ${updatedDate.tz(moment.tz.guess()).format('LTS')}`;
  }

  sortDateToUserTimeZoneInObject(items, column, save_old = false) {
    items.forEach(item => {
      item[column] = this.sortDateToUserTimeZone(new Date(item[column]));
      if (save_old) {
        item.datetime_old = new Date(item[column]).toISOString().slice(0, 19).replace('T', ' ');
      }
    });

    return items;
  }
}

export default new SortService;
